import React from 'react';
import styled from 'styled-components';

import { PrivacyBanner, MedicareBanner } from './BannerCards';
import { DEFAULT_MEDICARE_DESTINATION, MedicareDestination } from '../../../constants';

const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizing-md);
`;

export const getBanners = (
  isFirstPageView: boolean,
  isMedicareEnabled: boolean = true,
  medicareDestination: MedicareDestination = DEFAULT_MEDICARE_DESTINATION,
) => {
  const banners = [
    <PrivacyBanner isFirstPageView={isFirstPageView} key="privacy" />,
    isMedicareEnabled ? (
      <MedicareBanner
        isFirstPageView={isFirstPageView}
        medicareDestination={medicareDestination}
        key="medicare"
      />
    ) : null,
  ].filter(Boolean);

  return <BannerContainer>{banners}</BannerContainer>;
};

export { PrivacyBanner, MedicareBanner } from './BannerCards';
